// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"501":"component---src-pages-contact-js","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"501":"bafae66c735df3cbb627","532":"306460a6aeb41734a62c","678":"ba517fe9d9f44a6ce1ab","883":"d6293194a373b15caf28"}[chunkId] + ".js";
};